<div class="videocontainer">
  <iframe
    [src]="videolink"
    frameborder="0"
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
  ></iframe>
</div>

<div class="description" [class.empty]="!description">
  @if (description) {
  <p>
    {{ description }}
  </p>
  }
  <div class="actions">
    @if (!watchLater()) {
    <button mat-button color="primary" (click)="bookmark()">
      <mat-icon>bookmark</mat-icon>
      {{ 'embeddedVideo.saveForLater' | translate }}
    </button>
    } @if (watchLater()) {
    <button mat-button class="saved" color="primary" (click)="unbookmark()">
      <mat-icon>done</mat-icon>
      {{ 'embeddedVideo.savedForLater' | translate }}
    </button>
    }
  </div>
</div>
